import { writable } from 'svelte/store';

import type { Device } from 'src/types/Device';

function create_updating_devices() {
	const { subscribe, set, update } = writable(
		JSON.parse(localStorage.getItem('updating_devices ')) || {},
	);

	return {
		subscribe,
		set,
		update: (id, data: { fw: string; ts: number }) =>
			update((updating_devices) => {
				return { ...updating_devices, [id]: data };
			}),
		updateProgress: (id, prog) =>
			update((updating_devices) => {
				return { ...updating_devices, [id]: { ...updating_devices[id], prog } };
			}),
		remove: (id) =>
			update((updating_devices) => {
				delete updating_devices[id];
				return updating_devices;
			}),
		reset: () => set({}),
	};
}

export const updating_devices = create_updating_devices();
updating_devices.subscribe((val) => localStorage.setItem('updating_devices ', JSON.stringify(val)));

function create_firmwares() {
	const { subscribe, set, update } = writable(JSON.parse(localStorage.getItem('firmwares')) || {});

	return {
		subscribe,
		set,
		update: (new_device) =>
			update((firmwares) => {
				return { ...firmwares, [new_device.id]: new_device };
			}),
		remove: (id) =>
			update((firmwares) => {
				delete firmwares[id];
				return firmwares;
			}),
		reset: () => set({}),
	};
}

export const firmwares = create_firmwares();
firmwares.subscribe((val) => localStorage.setItem('firmwares', JSON.stringify(val)));

function create_firmwares_gen_2() {
	const { subscribe, set, update } = writable(
		JSON.parse(localStorage.getItem('firmwares_gen_2')) || {},
	);

	return {
		subscribe,
		set,
		update: (id, fw, ts) =>
			update((firmwares_gen_2) => {
				return { ...firmwares_gen_2, [id]: fw, ts: ts };
			}),
		remove: (id) =>
			update((firmwares_gen_2) => {
				delete firmwares_gen_2[id];
				return firmwares_gen_2;
			}),
		reset: () => set({}),
	};
}

export const firmwares_gen_2 = create_firmwares_gen_2();
firmwares_gen_2.subscribe((val) => localStorage.setItem('firmwares_gen_2', JSON.stringify(val)));

function create_firmwares_gen_gble() {
	const { subscribe, set, update } = writable(
		JSON.parse(localStorage.getItem('firmwares_gen_gble')) || {},
	);

	return {
		subscribe,
		set,
		update: (type, fw) =>
			update((firmwares_gen_gble) => {
				return { ...firmwares_gen_gble, [type]: { version: fw } };
			}),
		remove: (id) =>
			update((firmwares_gen_gble) => {
				delete firmwares_gen_gble[id];
				return firmwares_gen_gble;
			}),
		reset: () => set({}),
	};
}

export const firmwares_gen_gble = create_firmwares_gen_gble();
firmwares_gen_gble.subscribe((val) => localStorage.setItem('firmwares_gen_gble', JSON.stringify(val)));

function create_pending_commands() {
	const { subscribe, set, update } = writable(
		JSON.parse(localStorage.getItem('pending_commands ')) || {},
	);

	return {
		subscribe,
		set,
		update: (id, command) =>
			update((pending_commands) => {
				return { ...pending_commands, [id]: command };
			}),
		remove: (id) =>
			update((pending_commands) => {
				delete pending_commands[id];
				return pending_commands;
			}),
		reset: () => set({}),
	};
}

export const pending_commands = create_pending_commands();
pending_commands.subscribe((val) => localStorage.setItem('pending_commands', JSON.stringify(val)));

function create_rebooting_devices() {
	const { subscribe, set, update } = writable(
		JSON.parse(localStorage.getItem('rebooting_devices ')) || [],
	);

	return {
		subscribe,
		set,
		update: (device) =>
			update((rebooting_devices) => {
				rebooting_devices.push(device);
				return [...new Set(rebooting_devices)];
			}),
		remove: (device) =>
			update((rebooting_devices) => {
				let index_for_remove;
				rebooting_devices.forEach((id, i) => {
					if (id === device) {
						index_for_remove = i;
					}
				});
				rebooting_devices.splice(index_for_remove, 1);
				return rebooting_devices;
			}),
	};
}

export const rebooting_devices = create_rebooting_devices();
rebooting_devices.subscribe((val) => localStorage.setItem('rebooting_devices ', JSON.stringify(val)));

function create_wifi_updating_store() {
	const { subscribe, set, update } = writable(
		JSON.parse(localStorage.getItem('wifi_updating_devices ')) || [],
	);

	return {
		subscribe,
		set,
		update: (device: Device, channel: number, desired_wifi: string) =>
			update((updating_wifi) => {
				updating_wifi.push({ [device.id]: { channel, desired_wifi } });
				return [...new Set(updating_wifi.map((x) => JSON.stringify(x)))].map((y: any) =>
					JSON.parse(y),
				);
			}),
		remove: (id_to_remove) =>
			update((updating_wifi) => {
				let index_for_remove;
				updating_wifi.forEach((id, i) => {
					if (id === id_to_remove) {
						index_for_remove = i;
					}
				});
				updating_wifi.splice(index_for_remove, 1);
				return updating_wifi;
			}),
	};
}

export const wifi_updating_devices = create_wifi_updating_store();
wifi_updating_devices.subscribe((val) =>
	localStorage.setItem('wifi_updating_devices ', JSON.stringify(val)),
);
